import React, { useState, useEffect, useContext } from "react";
import {
  Table,
  Button,
  Select,
  Pagination,
  Dropdown,
  Menu,
  Form,
  Tag,
  Modal,
  Row,
  Input,
  Tabs,
  Col,
  DatePicker,
  Collapse,
  Popconfirm,
} from "antd";
import { FullscreenModal } from "../../../components/fullscreen-modal";
import dayjs from "dayjs";
// import { FaX } from "react-icons/fa6"; // Removing duplicate FaX
import styles from "./list.module.css";
import { DownOutlined, SearchOutlined } from "@ant-design/icons";
import {
  eFormAction,
  eFORMSTATUS,
  eResultCode,
  eSendAlertType,
  eUSER_FORM_TYPE,
  eUserType,
  eUSER_FORM_TYPE_NAME,
} from "../../../utils/enum";
import useFetch from "../../../hooks/useFetch";
import Text, { LanguageContext } from "../../../context/language-context";
import {
  FaCheck,
  FaFileExport,
  FaFilePdf,
  FaFilter,
  FaX,
} from "react-icons/fa6";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import {
  AddComment,
  DeleteComment,
  ExportDocuments,
  ExportExcel,
  ExportMultiplePdfs,
  ExportSinglePdf,
  getUsersData,
  GetRemarks,
  SendAlerts,
  updateFormStatus,
} from "../../../utils/api.constant";
import { AlignType } from "rc-table/lib/interface";
import useToast from "../../../hooks/useToast";
import { ToastOpen, ToastType } from "../../../state/toast/slice";
// import { FaCheck, FaTimes } from "react-icons/fa"; // Removing duplicate FaCheck
import { Footer } from "antd/es/layout/layout";
import { getNumberInLanguage } from "../../../utils/helperFunctions";
import { select } from "react-cookies";
import { LoaderContext } from "../../../context/loader";
import Utils from "../../../utils";
import { CURRENT_YEAR } from "../../../utils/constants";
const { Option } = Select;

type TabType = {
  label: string;
  value: number;
  count?: number;
};

const formItemLayout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  },
};

function AdminDashboard() {
  const [isActive, setIsActive] = useState(eUSER_FORM_TYPE.ALL);
  const [countPerPage, setCountPerPage] = useState(10);
  const [form] = Form.useForm();
  const [data, setData] = useState<any[]>([]);
  const [selectedYear, setSelectedYear] = useState<number>(CURRENT_YEAR);
  const [filter, setFilter] = useState<string>("");
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [selectedIds, setSelectedIds] = useState<any[]>([]);
  const [selectedUserIds, setSelectedUserIds] = useState<any[]>([]);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [selectedPDFId, setSelectedPDFId] = useState([]);
  const { userLanguage } = useContext(LanguageContext);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSendAlertModalOpen, setIsSendAlertModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState<any>(null);
  const [remarks, setRemarks] = useState<any[]>([]);
  const [modalComment, setmodalComment] = useState("");
  const { onShowToast } = useToast();
  const contextForLoader = useContext(LoaderContext);
  const { isLoading, setIsLoading } = contextForLoader as any;
  const Text_SelectAtLeastOneUser = Text({
    tid: "SELECT_AT_LEAST_ONE_USER",
    def: "Select at least one user",
  });
  const [modalActiveTab, setModalActiveTab] = useState("1");
  const defaultTabOptions = [
    {
      label: Text({ tid: "ALL_TAB", def: "All" }),
      value: eUSER_FORM_TYPE.ALL,
    },
    {
      label: Text({ tid: "STUDENT", def: "Vedavidyarthi" }),
      value: eUSER_FORM_TYPE.STUDENT,
    },
    {
      label: Text({ tid: "TEACHER", def: "Vedaadhyapaka" }),
      value: eUSER_FORM_TYPE.TEACHER,
    },
    {
      label: Text({ tid: "SCHOOL", def: "Vedavidyalaya" }),
      value: eUSER_FORM_TYPE.SCHOOL,
    },
    {
      label: Text({ tid: "REGISTERED", def: "Registered" }),
      value: eUSER_FORM_TYPE.REGISTERED,
    },
  ];
  const [tabOptions, setTabOptions] = useState<TabType[]>(defaultTabOptions);
  const { post } = useFetch();
  const baseUrl = window.location.origin;

  const onTabClick = (val: number) => {
    setIsActive(val);
    setSelectedIds([]);
    setSelectedUserIds([]);
    setRemarks([]);
    setSelectedPDFId([]);
    setFilter("");
    setSearchQuery("");
  };

  const fetchUsersData = async (type: number, year: number = CURRENT_YEAR) => {
    setIsLoading(true);
    try {
      const requestPayload = {
        data: {
          userFormType: type,
          year: year,
        },
      };
      const response = await post(getUsersData, requestPayload);
      const { data, dataResponse } = response;
      const { returnCode, description } = dataResponse;
      if (
        [eResultCode.SUCCESS, eResultCode.NO_DATA_FOUND].includes(returnCode)
      ) {
        const formattedData = data.list.map((item: any) => {
          return {
            ...item,
            key:
              type === eUSER_FORM_TYPE.REGISTERED
                ? item.userId
                : item.userFormMappingId,
          };
        });

        setData(returnCode === eResultCode.SUCCESS ? formattedData : []);
        const countMapping: { [key: number]: string } = {
          [eUSER_FORM_TYPE.STUDENT]: "studentCount",
          [eUSER_FORM_TYPE.TEACHER]: "teacherCount",
          [eUSER_FORM_TYPE.SCHOOL]: "schoolCount",
          [eUSER_FORM_TYPE.REGISTERED]: "noFormCount",
        };

        setTabOptions(
          defaultTabOptions.map((item) => {
            let countVal: any = 0;
            if (item.value === eUSER_FORM_TYPE.ALL) {
              const sCount = parseInt(data?.studentCount || "0", 10);
              const tCount = parseInt(data?.teacherCount || "0", 10);
              const scCount = parseInt(data?.schoolCount || "0", 10);
              const rCount = parseInt(data?.noFormCount || "0", 10);
              countVal = sCount + tCount + scCount + rCount;
            } else {
              countVal = data?.[countMapping[item.value]];
            }
            return {
              ...item,
              count: countVal,
            };
          }),
        );
      }
    } catch (error) {
      console.error(error);
    }
    setIsLoading(false);
  };

  const handleSendAlert = async (values: {
    subject: string;
    message: string;
    messageType: number;
  }) => {
    setIsLoading(true);
    try {
      const payload: any = {
        data: {
          // ids: selectedIds,
          ids: selectedUserIds,
          subject: values.subject,
          message: values.message,
          alertCode: values.messageType,
        },
      };

      const response = await post(SendAlerts, payload);
      const { dataResponse } = response;
      const { returnCode, description } = dataResponse;
      if (returnCode == eResultCode.SUCCESS) {
        onShowToast({
          type: ToastType.success,
          title: <FaCheck />,
          position: ToastOpen.leftBottom,
          content: description,
        });
        setTimeout(() => {
          setIsSendAlertModalOpen(false);
        }, 1000);
      }
    } catch (error) {
      console.error("Dashboard Send Alert Error : ", error);
    }
    setIsLoading(false);
  };

  const handleOpenExternal = async (
    filePath: any,
    targetBlank: boolean = false,
  ) => {
    const fileURL = `${process.env.REACT_APP_PUBLIC_API_MEDIA_BASEURL}/${filePath}`;
    // window.open(fileURL, "_blank");
    try {
      const response = await fetch(fileURL, { mode: "cors" });
      if (!response.ok) throw new Error("Network response was not ok");
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute(
        "download",
        filePath.split(/[\/\\]/).pop() || "file.pdf",
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("PDF download failed:", error);
    }
  };

  const exportExcel = async () => {
    setIsLoading(true);
    try {
      const requestPayload = {
        data: {
          userFormType: isActive,
          ids: selectedIds.length > 0 ? selectedIds : [],
          year: selectedYear,
        },
      };
      const response = await post(ExportExcel, requestPayload);
      const { data, dataResponse } = response;
      const { returnCode, description } = dataResponse;
      if (
        [eResultCode.SUCCESS, eResultCode.NO_DATA_FOUND].includes(returnCode)
      ) {
        handleOpenExternal(data.curentFilePath);
      }
    } catch (error) {
      console.error(error);
    }
    setIsLoading(false);
  };

  const getStatusColor = (status: number) => {
    switch (status) {
      case eFORMSTATUS.STAGE1APPROVED:
      case eFORMSTATUS.STAGE2APPROVED:
      case eFORMSTATUS.INTERVIEWSTAGE:
        return "green";
      case eFORMSTATUS.STAGE1SUBMITTED:
      case eFORMSTATUS.STAGE2SUBMITTED:
        return "black";
      case eFORMSTATUS.STAGE1REJECTED:
      case eFORMSTATUS.STAGE2REJECTED:
        return "red";
      case eFORMSTATUS.STAGE1INPROGRESS:
      case eFORMSTATUS.STAGE2INPROGRESS:
        return "black";
      case eFORMSTATUS.STAGE2SELECTED:
        return "orange";
      case eFORMSTATUS.REGISTERED:
        return "gray";
      default:
        return "gray";
    }
  };

  const statusOptions = [
    {
      label: Text({ tid: "STAGE_1_IN_PROGRESS", def: "Stage 1 In Progress" }),
      value: eFORMSTATUS.STAGE1INPROGRESS,
    },
    {
      label: Text({ tid: "STAGE_1_SUBMITTED", def: "Stage 1 Submitted" }),
      value: eFORMSTATUS.STAGE1SUBMITTED,
    },
    {
      label: Text({ tid: "STAGE_1_FORM_REJECTED", def: "Stage 1 Rejected" }),
      value: eFORMSTATUS.STAGE1REJECTED,
    },
    {
      label: Text({ tid: "STAGE_1_FORM_APPROVAL", def: "Stage 1 Approved" }),
      value: eFORMSTATUS.STAGE1APPROVED,
    },
    {
      label: Text({ tid: "STAGE_2_IN_PROGRESS", def: "Stage 2 In Progress" }),
      value: eFORMSTATUS.STAGE2INPROGRESS,
    },
    {
      label: Text({ tid: "STAGE_2_SUBMITTED", def: "Stage 2 Submitted" }),
      value: eFORMSTATUS.STAGE2SUBMITTED,
    },
    {
      label: Text({ tid: "STAGE_2_FORM_APPROVAL", def: "Stage 2 Approved" }),
      value: eFORMSTATUS.STAGE2APPROVED,
    },
    {
      label: Text({ tid: "STAGE_2_FORM_REJECTED", def: "Stage 2 Rejected" }),
      value: eFORMSTATUS.STAGE2REJECTED,
    },
    {
      label: Text({ tid: "INTERVIEW_STAGE", def: "Interview Stage" }),
      value: eFORMSTATUS.INTERVIEWSTAGE,
    },
    {
      label: Text({ tid: "FORM_SELECTED", def: "Selected" }),
      value: eFORMSTATUS.STAGE2SELECTED,
    },
    {
      label: Text({ tid: "REGISTERED", def: "Registered" }),
      value: eFORMSTATUS.REGISTERED,
    },
  ];

  const columns = [
    {
      title: Text({ tid: "APPLICATION_NUMBER", def: "Application No" }),
      dataIndex: "applicationNumber",
      key: "applicationNumber",
      width: "15%",
      render: (text: string) => <span>{text || "-"}</span>,
    },
    {
      title: Text({ tid: "NAME", def: "NAME" }),
      dataIndex: "userName",
      key: "userName",
      width: isActive !== eUSER_FORM_TYPE.REGISTERED ? "20%" : "30%",
    },
    ...(isActive === eUSER_FORM_TYPE.ALL
      ? [
          {
            title: Text({ tid: "FORM_TYPE", def: "Form Type" }),
            dataIndex: "userFormType",
            key: "userFormType",
            width: "15%",
            render: (userFormType: number) => {
              const labelMapping: { [key: number]: string } = {
                [eUSER_FORM_TYPE.STUDENT]: "STUDENT",
                [eUSER_FORM_TYPE.TEACHER]: "TEACHER",
                [eUSER_FORM_TYPE.SCHOOL]: "SCHOOL",
                [eUSER_FORM_TYPE.REGISTERED]: "REGISTERED",
              };
              const tid = labelMapping[userFormType] || "UNKNOWN";
              return Text({
                tid: tid,
                def: eUSER_FORM_TYPE_NAME[userFormType] || "Unknown",
              });
            },
          },
        ]
      : []),
    // Only show FORMCODE column if not REGISTERED
    ...(isActive !== eUSER_FORM_TYPE.REGISTERED
      ? [
          {
            title: Text({ tid: "FORMCODE", def: "FORMCODE" }),
            dataIndex: "formCode",
            key: "formCode",
            width: "10%",
          },
        ]
      : []),
    {
      title: Text({ tid: "EMAIL", def: "EMAIL" }),
      dataIndex: "emailId",
      key: "emailId",
      width: isActive !== eUSER_FORM_TYPE.REGISTERED ? "20%" : "25%", // You can adjust this if needed
    },
    {
      title: Text({ tid: "mobile_number", def: "mobile_number" }),
      dataIndex: "mobile",
      key: "mobile",
      width: isActive !== eUSER_FORM_TYPE.REGISTERED ? "15%" : "20%",
    },
    {
      title: Text({ tid: "STATUS", def: "STATUS" }),
      dataIndex: "currentStage",
      key: "currentStage",
      width: isActive !== eUSER_FORM_TYPE.REGISTERED ? "15%" : "20%",
      // filters: statusOptions.map((status) => ({
      //   text: status.label,
      //   value: status.value,
      // })),
      // onFilter: (item: any, record: any) =>  record.currentStage === item,
      render: (currentStage: number) => (
        <Tag color={getStatusColor(currentStage)}>
          {statusOptions.find((status) => status.value === currentStage)?.label}
        </Tag>
      ),
    },
    ...(isActive !== eUSER_FORM_TYPE.REGISTERED
      ? [
          {
            title: Text({ tid: "ACTION", def: "ACTION" }),
            key: "action",
            width: "15%",
            align: "center" as AlignType,
            render: (_: any, record: any) => (
              <>
                {record.currentStage !== eFORMSTATUS.STAGE1INPROGRESS ? (
                  <Button
                    size='small'
                    onClick={() => {
                      setIsModalOpen(true);
                      setSelectedUser(record);
                      setmodalComment("");
                    }}
                  >
                    {Text({ tid: "VIEW", def: "VIEW" })}
                  </Button>
                ) : null}
              </>
            ),
          },
        ]
      : []),
  ];

  // -------------------- pdf download for Multiple User -----------------------------
  const exportSelectedDocuments = async (id: number | null = null) => {
    setIsLoading(true);
    if (selectedIds.length > 0 || id !== null) {
      try {
        const payload = {
          data: {
            ids: id !== null ? [id] : selectedIds,
            userFormType: isActive,
          },
        };
        const response = await post(ExportDocuments, payload);
        const { dataResponse } = response;
        const { returnCode, description } = dataResponse;
        if (returnCode == eResultCode.SUCCESS) {
          handleOpenExternal(response.data.filePath);
          onShowToast({
            type: ToastType.success,
            title: <FaCheck />,
            position: ToastOpen.leftBottom,
            content: "Form Submitted Successfully!",
          });
        }
      } catch (error) {
        console.error("Dashboard Export Documents Error : ", error);
      }
    } else {
      onShowToast({
        type: ToastType.success,
        title: <FaCheck />,
        position: ToastOpen.leftBottom,
        content: Text_SelectAtLeastOneUser,
      });
    }
    setIsLoading(false);
  };

  const exportSelectedPdfOrBinder = async (
    id: number[] | null = null,
    isAffidavit: boolean,
    isDocument: boolean,
  ) => {
    setIsLoading(true);
    if (selectedIds.length > 0) {
      try {
        const payload = {
          data: {
            ids: id !== null ? id : selectedIds,
            userFormType: isActive,
            isAffidavit: isAffidavit,
            isDocument: isDocument,
          },
        };
        const response = await post(ExportMultiplePdfs, payload);
        const { dataResponse } = response;
        const { returnCode, description } = dataResponse;
        if (returnCode == eResultCode.SUCCESS) {
          handleOpenExternal(response.data.filePath);
          onShowToast({
            type: ToastType.success,
            title: <FaCheck />,
            position: ToastOpen.leftBottom,
            content: "Form Submitted Successfully!",
          });
        }
      } catch (error) {
        console.error("Dashboard Export Binder Or Pdf Error : ", error);
      }
    } else {
      onShowToast({
        type: ToastType.success,
        title: <FaCheck />,
        position: ToastOpen.leftBottom,
        content: Text_SelectAtLeastOneUser,
      });
    }
    setIsLoading(false);
  };

  const menu = (
    <Menu
      className={styles.dropdownMenu} // Applying custom class
      items={[
        {
          key: "1",
          label: (
            <div
              className={styles.dropdownItem}
              onClick={() => {
                exportSelectedPdfOrBinder(selectedIds, true, false);
              }}
            >
              {Text({
                tid: "EXPORT_PDF_WITH_AFFIDAVIT",
                def: "Export Pdf with Affidavit",
              })}
            </div>
          ),
        },
        {
          key: "2",
          label: (
            <div
              className={styles.dropdownItem}
              onClick={() => {
                exportSelectedPdfOrBinder(selectedIds, false, false);
              }}
            >
              {Text({
                tid: "EXPORT_PDF_WITHOUT_AFFIDAVIT",
                def: "Export PDF without Affidavit",
              })}
            </div>
          ),
        },
        {
          key: "3",
          label: (
            <div
              className={styles.dropdownItem}
              onClick={() => {
                exportSelectedPdfOrBinder(selectedIds, true, true);
              }}
            >
              {Text({
                tid: "EXPORT_BINDER_WITH_AFFIDAVIT",
                def: "Export Binder with Affidavit",
              })}
            </div>
          ),
        },
        {
          key: "4",
          label: (
            <div
              className={styles.dropdownItem}
              onClick={() => {
                exportSelectedPdfOrBinder(selectedIds, false, true);
              }}
            >
              {Text({
                tid: "EXPORT_BINDER_WITHOUT_AFFIDAVIT",
                def: "Export Binder without Affidavit",
              })}
            </div>
          ),
        },
        {
          key: "5",
          label: (
            <div
              className={styles.dropdownItem}
              onClick={() => {
                exportSelectedDocuments();
              }}
            >
              {Text({
                tid: "EXPORT_DOCUMENTS",
                def: "Export Documents",
              })}
            </div>
          ),
        },
      ]}
    />
  );

  // -------------------- pdf download for specific user -----------------------------
  const exportSinglePdfOrBinder = async (
    id: number | null = null,
    isAffidavit: boolean,
    isDocument: boolean,
    isPreview: boolean = false,
  ) => {
    setIsLoading(true);
    try {
      const payload = {
        data: {
          id: id,
          userFormType: isActive,
          isAffidavit: isAffidavit,
          isDocument: isDocument,
          isPtOne: modalActiveTab === "1",
          preview: isPreview,
        },
      };
      const response = await post(ExportSinglePdf, payload);
      const { dataResponse } = response;
      const { returnCode, description } = dataResponse;
      if (returnCode == eResultCode.SUCCESS) {
        if (isPreview === false) {
          handleOpenExternal(response.data.filePath, true);
        } else {
          window.location.reload();
        }
        onShowToast({
          type: ToastType.success,
          title: <FaCheck />,
          position: ToastOpen.leftBottom,
          content: "Form Submitted Successfully!",
        });
      }
    } catch (error) {
      console.error("Dashboard Export Binder Or Pdf Error : ", error);
    }
    setIsLoading(false);
  };

  const specificMenu = (record: any) => {
    return (
      <Menu
        className={styles.dropdownMenu}
        items={[
          {
            key: "1",
            label: (
              <div
                className={styles.dropdownItem}
                onClick={() => {
                  exportSinglePdfOrBinder(
                    record.key,
                    true,
                    false,
                  );
                }}
              >
                {Text({
                  tid: "EXPORT_PDF_WITH_AFFIDAVIT",
                  def: "Export Pdf with Affidavit",
                })}
              </div>
            ),
          },
          {
            key: "2",
            label: (
              <div
                className={styles.dropdownItem}
                onClick={() => {
                  exportSinglePdfOrBinder(
                    record.key,
                    false,
                    false,
                  );
                }}
              >
                {Text({
                  tid: "EXPORT_PDF_WITHOUT_AFFIDAVIT",
                  def: "Export PDF without Affidavit",
                })}
              </div>
            ),
          },
          {
            key: "3",
            label: (
              <div
                className={styles.dropdownItem}
                onClick={() => {
                  exportSinglePdfOrBinder(record.key, true, true);
                }}
              >
                {Text({
                  tid: "EXPORT_BINDER_WITH_AFFIDAVIT",
                  def: "Export Binder with Affidavit",
                })}
              </div>
            ),
          },
          {
            key: "4",
            label: (
              <div
                className={styles.dropdownItem}
                onClick={() => {
                  exportSinglePdfOrBinder(
                    record.key,
                    false,
                    true,
                  );
                }}
              >
                {Text({
                  tid: "EXPORT_BINDER_WITHOUT_AFFIDAVIT",
                  def: "Export Binder without Affidavit",
                })}
              </div>
            ),
          },
          {
            key: "5",
            label: (
              <div
                className={styles.dropdownItem}
                onClick={() => {
                  exportSelectedDocuments(record.key);
                }}
              >
                {Text({
                  tid: "EXPORT_DOCUMENTS",
                  def: "Export Documents",
                })}
              </div>
            ),
          },
        ]}
      />
    );
  };

  // ---------------------------------------------------------------------------------
  const handleUpdateFormStatus = async (
    selectedUser: any,
    action: number,
    comment: string,
  ) => {
    setIsLoading(true);
    try {
      let newStatus = selectedUser.currentStage;

      if (action === eFormAction.APPROVE) {
        if (
          selectedUser.currentStage === eFORMSTATUS.STAGE1SUBMITTED ||
          selectedUser.currentStage === eFORMSTATUS.STAGE1REJECTED
        ) {
          newStatus = eFORMSTATUS.STAGE1APPROVED;
        } else if (
          selectedUser.currentStage === eFORMSTATUS.STAGE2SUBMITTED ||
          selectedUser.currentStage === eFORMSTATUS.STAGE2REJECTED
        ) {
          newStatus = eFORMSTATUS.STAGE2APPROVED;
        }
      } else if (action === eFormAction.REJECT) {
        if (
          selectedUser.currentStage === eFORMSTATUS.STAGE1SUBMITTED ||
          selectedUser.currentStage === eFORMSTATUS.STAGE1APPROVED
        ) {
          newStatus = eFORMSTATUS.STAGE1REJECTED;
        } else if (
          selectedUser.currentStage === eFORMSTATUS.STAGE2SUBMITTED ||
          selectedUser.currentStage === eFORMSTATUS.STAGE2APPROVED
        ) {
          newStatus = eFORMSTATUS.STAGE2REJECTED;
        } else if (selectedUser.currentStage === eFORMSTATUS.INTERVIEWSTAGE) {
          newStatus = eFORMSTATUS.STAGE2REJECTED;
        } else if (selectedUser.currentStage === eFORMSTATUS.STAGE2SELECTED) {
          newStatus = eFORMSTATUS.INTERVIEWSTAGE;
        }
      } else if (action === eFormAction.SELECT) {
        if (selectedUser.currentStage === eFORMSTATUS.STAGE2APPROVED) {
          newStatus = eFORMSTATUS.INTERVIEWSTAGE;
        } else if (selectedUser.currentStage === eFORMSTATUS.INTERVIEWSTAGE) {
          newStatus = eFORMSTATUS.STAGE2SELECTED;
        }
      }

      const requestPayload = {
        data: {
          userFormMappingId: selectedUser.userFormMappingId,
          userId: selectedUser.userId,
          newStatus: newStatus,
          comment: comment,
          year: CURRENT_YEAR,
        },
      };

      const response = await post(updateFormStatus, requestPayload);
      const { dataResponse } = response;
      const { returnCode } = dataResponse;
      if (returnCode === eResultCode.SUCCESS) {
        fetchUsersData(isActive, selectedYear);
        setIsModalOpen(false);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setmodalComment("");
      setSelectedUser(null);
      setIsModalOpen(false);
    }
    setIsLoading(false);
  };

  const fetchRemarks = async (userFormMappingId: number) => {
    try {
      const requestPayload = {
        data: {
          userFormMappingId: userFormMappingId,
        },
      };
      const response = await post(GetRemarks, requestPayload);
      const { data, dataResponse } = response;
      const { returnCode } = dataResponse;
      if (returnCode === eResultCode.SUCCESS) {
        const remarksData = Array.isArray(data) ? data : data?.remarks || [];
        setRemarks(remarksData);
        setSelectedUser((prevUser: any) => ({
          ...prevUser,
          comment: remarksData,
        }));
      }
    } catch (error) {
      console.error("Fetch Remarks Error:", error);
    }
  };

  const handleAddComment = async () => {
    if (!modalComment.trim()) return;
    setIsLoading(true);
    try {
      const requestPayload = {
        data: {
          userFormMappingId: selectedUser.userFormMappingId,
          currentStage: selectedUser.currentStage,
          userId: selectedUser.userId,
          comment: modalComment,
          year: CURRENT_YEAR,
        },
      };

      const response = await post(AddComment, requestPayload);
      const { dataResponse } = response;
      if (dataResponse?.returnCode === eResultCode.SUCCESS) {
        setmodalComment("");
        fetchRemarks(selectedUser.userFormMappingId);
      }
    } catch (error) {
      console.error("Add Comment Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteComment = async (commentId: string) => {
    setIsLoading(true);
    try {
      const requestPayload = {
        data: {
          id: commentId,
          userFormMappingId: selectedUser.userFormMappingId,
        },
      };

      const response = await post(DeleteComment, requestPayload);
      const { dataResponse } = response;
      if (dataResponse?.returnCode === eResultCode.SUCCESS) {
        fetchRemarks(selectedUser.userFormMappingId);
      }
    } catch (error) {
      console.error("Delete Comment Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const filteredData = data.filter((item) => {
    let match = true;
    if (filter !== "") {
      match = match && item.currentStage === filter;
    }
    if (searchQuery.trim() !== "") {
      const q = searchQuery.toLowerCase();
      const nameMatch = item.userName?.toLowerCase().includes(q);
      const emailMatch = item.emailId?.toLowerCase().includes(q);
      const mobileMatch = item.mobile?.toLowerCase().includes(q);
      const codeMatch = item.formCode?.toLowerCase().includes(q);
      const appNoMatch = item.applicationNumber?.toLowerCase().includes(q);
      match =
        match &&
        (!!nameMatch ||
          !!emailMatch ||
          !!mobileMatch ||
          !!codeMatch ||
          !!appNoMatch);
    }
    return match;
  });

  // Utility function to check if form is in progress
  const isInProgress = (stage: number) =>
    [eFORMSTATUS.STAGE1INPROGRESS, eFORMSTATUS.STAGE2INPROGRESS].includes(
      stage,
    );

  useEffect(() => {
    fetchUsersData(isActive, selectedYear);
  }, [isActive, userLanguage, selectedYear]);

  // Set the correct active tab when modal opens
  useEffect(() => {
    if (selectedUser) {
      if (
        selectedUser.currentStage > eFORMSTATUS.STAGE1APPROVED &&
        selectedUser.currentStage !== eFORMSTATUS.STAGE2INPROGRESS
      ) {
        setModalActiveTab("2");
      } else {
        setModalActiveTab("1");
      }
    }
  }, [selectedUser]);

  useEffect(() => {
    if (isModalOpen && selectedUser) {
      fetchRemarks(selectedUser.userFormMappingId);
    }
  }, [isModalOpen]);

  const pleaseSelectUserValidation = () => {
    onShowToast({
      type: ToastType.error,
      title: <FaCheck />,
      position: ToastOpen.leftBottom,
      content: Text_SelectAtLeastOneUser,
    });
  };

  return (
    <>
      <div className={styles.dashboardContainer}>
        <div className={styles.statsContainer}>
          {tabOptions.map(({ label, value, count }, index) => (
            <div
              key={index}
              className={styles.statCard}
            >
              <h1 className={styles.statCount}>
                {isNaN(count as number)
                  ? 0
                  : getNumberInLanguage(Number(count))}
              </h1>
              <p>
                {Text({ tid: "DASHBOARD_TOTAL", def: "Total" })} {label}
              </p>
            </div>
          ))}
        </div>

        <div className={styles.container}>
          <div className={styles.tabWrapper}>
            {tabOptions.map(({ label, value }, index) => (
              <button
                key={index}
                className={`${styles.tab} ${isActive === value ? styles.active_tab : ""}`}
                onClick={() => onTabClick(value)}
              >
                <p
                  className={`${styles.tab_text} ${
                    isActive === value ? styles.active_tab_text : ""
                  }`}
                >
                  {label}
                </p>
              </button>
            ))}
          </div>
          <div className={styles.lineWrapper}>
            <hr className={styles.red_line} />
          </div>
        </div>
        <div className={styles.filtersWrapper}>
          <div
            className={styles.filtersContainer}
            id='filtersContainer'
          >
            <Select
              value={filter}
              onChange={setFilter}
              className={styles.filterDropdown}
              placeholder={Text({ tid: "select", def: "Filter by Status" })}
            >
              <Option value=''>
                {Text({ tid: "select", def: "Filter by Status" })}
              </Option>
              {statusOptions.map(({ label, value }) => (
                <Option
                  key={value}
                  value={value}
                >
                  {label}
                </Option>
              ))}
            </Select>
            <DatePicker
              picker='year'
              value={dayjs().year(selectedYear)}
              onChange={(date) => {
                if (date) {
                  setSelectedYear(date.year());
                }
              }}
              disabledDate={(current) => {
                return (
                  current &&
                  (current.year() > CURRENT_YEAR || current.year() < 2025)
                );
              }}
              placeholder={Text({ tid: "SELECT_YEAR", def: "Select Year" })}
              className={styles.filterDropdown}
            />
            <Button
              icon={<FaX />}
              onClick={() => {
                setFilter("");
                setSearchQuery("");
                setSelectedYear(CURRENT_YEAR);
              }}
            >
              <span className='hideOnMobile'>
                {Text({ tid: "CLEAR", def: "CLEAR" })}
              </span>
            </Button>
          </div>
          <div className={styles.exportContainer}>
            <Input
              placeholder={Text({
                tid: "GLOBAL_SEARCH",
                def: "Search Name, Phone, Email, Code...",
              })}
              allowClear
              size='small'
              onChange={(e) => setSearchQuery(e.target.value)}
              value={searchQuery}
              className={styles.searchInput}
              suffix={<SearchOutlined />}
            />
            {isActive !== eUSER_FORM_TYPE.REGISTERED && (
              <div className={styles.exportButtonSection}>
                <Button
                  className={styles.docIcon}
                  onClick={() => {
                    exportExcel();
                  }}
                >
                  <img
                    src={baseUrl + "/csv.png"}
                    alt='csv'
                    width={40}
                  />
                </Button>
                {selectedIds.length === 0 ? (
                  <Button
                    className={styles.docIcon}
                    onClick={() => pleaseSelectUserValidation()}
                  >
                    <img
                      src={baseUrl + "/pdf.png"}
                      alt='pdf'
                      width={40}
                    />
                  </Button>
                ) : (
                  <Dropdown
                    overlay={menu}
                    trigger={["click"]}
                  >
                    <Button className={styles.docIcon}>
                      <img
                        src={baseUrl + "/pdf.png"}
                        alt='pdf'
                        width={40}
                      />
                    </Button>
                  </Dropdown>
                )}
              </div>
            )}

            <Button
              onClick={() => {
                setIsSendAlertModalOpen(true);
              }}
              disabled={selectedIds.length === 0}
            >
              {Text({ tid: "SET_ALERT", def: "SET_ALERT" })}
            </Button>
          </div>
          <Modal
            title={
              <div>
                {Text({ tid: "SEND_ALERT_MESSAGE", def: "SEND_ALERT_MESSAGE" })}
              </div>
            }
            open={isSendAlertModalOpen}
            onCancel={() => {
              setIsSendAlertModalOpen(false);
              form.resetFields();
            }}
            footer={null}
            centered
          >
            <Form
              {...formItemLayout}
              form={form}
              name='sendAlertForm'
              onFinish={handleSendAlert}
              className={styles.sendAlertModalBody}
              scrollToFirstError
              layout='vertical'
            >
              <Row>
                <Col xs={24}>
                  <Form.Item
                    name='subject'
                    label={Text({
                      tid: "SUBJECT",
                      def: "SUBJECT",
                    })}
                    rules={[
                      {
                        required: true,
                        message: Text({ tid: "REQUIRED", def: "Required" }),
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col xs={24}>
                  <Form.Item
                    name='messageType'
                    label={Text({
                      tid: "MESSAGE_TYPE",
                      def: "MESSAGE_TYPE",
                    })}
                    rules={[
                      {
                        required: true,
                        message: Text({ tid: "REQUIRED", def: "Required" }),
                      },
                    ]}
                  >
                    <Select>
                      <Select.Option value={eSendAlertType.EMAIL}>
                        {Text({ tid: "EMAIL", def: "E-Mail" })}
                      </Select.Option>
                      <Select.Option value={eSendAlertType.EMAILANDSMS}>
                        {Text({ tid: "EMAIL_AND_SMS", def: "E-Mail and SMS" })}
                      </Select.Option>
                      <Select.Option value={eSendAlertType.SMS}>
                        {Text({ tid: "SMS", def: "SMS" })}
                      </Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col xs={24}>
                  <Form.Item
                    name='message'
                    label={Text({
                      tid: "MESSAGE",
                      def: "MESSAGE",
                    })}
                    rules={[
                      {
                        required: true,
                        message: Text({ tid: "REQUIRED", def: "Required" }),
                      },
                    ]}
                  >
                    <Input.TextArea />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col className={styles.sendAlertModalFooter}>
                  <Button
                    htmlType='submit'
                    variant='filled'
                  >
                    {Text({ tid: "SUBMIT", def: "SUBMIT" })}
                  </Button>
                </Col>
              </Row>
            </Form>
          </Modal>
        </div>
        <Table
          columns={columns}
          dataSource={filteredData}
          rowHoverable={true}
          scroll={{ x: "80vw" }}
          rowSelection={{
            selectedRowKeys: selectedIds,
            onSelect: (record: any, selected: boolean) => {
              setSelectedIds((prevSelectedIds) =>
                selected
                  ? [...prevSelectedIds, record?.key]
                  : prevSelectedIds.filter(
                      (id) => id !== record?.key,
                    ),
              );
              setSelectedUserIds((prevSelectedUserIds) =>
                selected
                  ? [...prevSelectedUserIds, record?.userId]
                  : prevSelectedUserIds.filter((id) => id !== record?.userId),
              );
            },
            onSelectAll: (selected, selectedRows) => {
              setSelectedIds(
                selected
                  ? selectedRows.map((item) => item?.key)
                  : [],
              );
              setSelectedUserIds(
                selected ? selectedRows.map((item) => item?.userId) : [],
              );
            },
          }}
          pagination={{
            position: ["bottomCenter"],
            className: "tablePagination",
            defaultPageSize: 10,
            showSizeChanger: true,
            pageSizeOptions: ["10", "20", "50", "100"],
            showTotal: (total: any, range: any[]) =>
              `Showing ${range[0]}-${range[1]} of ${total} total entries`,
          }}
          rowKey={"key"}
        />
        {/* <Pagination
          current={pageNo}
          pageSize={countPerPage}
          total={filteredData.length}
          onChange={handlePageChange}
          showSizeChanger
          onShowSizeChange={(_, size) => setCountPerPage(size)}
          pageSizeOptions={["10", "25", "50", "100"]}
        /> */}
      </div>
      {selectedUser && (
        <FullscreenModal
          className={"adminModal"}
          open={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          customTitle={
            <div className={styles.modalHeader}>
              <h4 className={styles.modalTitle}>
                {Text({ tid: "PREVIEW", def: "PREVIEW" })}
              </h4>
              <div className={styles.modalFormStatus}>
                <Tag color={getStatusColor(selectedUser.currentStage)}>
                  {
                    statusOptions.find(
                      (status) => status.value === selectedUser.currentStage,
                    )?.label
                  }
                </Tag>
              </div>
            </div>
          }
          customFooter={
            <div className={styles.dashboardModalFooter}>
              <div className={styles.dashboardModalFooterSection}>
                <Button
                  key='reject'
                  onClick={() => {
                    handleUpdateFormStatus(
                      selectedUser,
                      eFormAction.REJECT,
                      modalComment,
                    );
                  }}
                  style={{
                    display:
                      isInProgress(selectedUser.currentStage) ||
                      selectedUser.currentStage ===
                        eFORMSTATUS.STAGE1REJECTED ||
                      selectedUser.currentStage === eFORMSTATUS.STAGE2REJECTED
                        ? "none"
                        : "inline-block",
                  }}
                >
                  {Text({ tid: "REJECT", def: "Reject" })}
                </Button>
                {/* Select for Interview or Final Selection button */}
                {(selectedUser.currentStage === eFORMSTATUS.STAGE2APPROVED ||
                  selectedUser.currentStage === eFORMSTATUS.INTERVIEWSTAGE) && (
                  <Button
                    key='select'
                    type='primary'
                    onClick={() => {
                      handleUpdateFormStatus(
                        selectedUser,
                        eFormAction.SELECT,
                        modalComment,
                      );
                    }}
                  >
                    {selectedUser.currentStage === eFORMSTATUS.INTERVIEWSTAGE
                      ? Text({ tid: "select", def: "Select" })
                      : Text({ tid: "select", def: "Select for Interview" })}
                  </Button>
                )}
                {/* Approve button */}
                <Button
                  key='approve'
                  type='primary'
                  onClick={() => {
                    handleUpdateFormStatus(
                      selectedUser,
                      eFormAction.APPROVE,
                      modalComment,
                    );
                  }}
                  style={{
                    display:
                      isInProgress(selectedUser.currentStage) ||
                      selectedUser.currentStage ===
                        eFORMSTATUS.STAGE1APPROVED ||
                      selectedUser.currentStage ===
                        eFORMSTATUS.STAGE2APPROVED ||
                      selectedUser.currentStage ===
                        eFORMSTATUS.STAGE2SELECTED ||
                      selectedUser.currentStage === eFORMSTATUS.INTERVIEWSTAGE
                        ? "none"
                        : "inline-block",
                  }}
                >
                  {Text({ tid: "APPROVE", def: "Approve" })}
                </Button>
              </div>
              <div className={styles.dashboardModalFooterSection}>
                <Button
                  onClick={() => {
                    exportSinglePdfOrBinder(
                      selectedUser.key,
                      true,
                      false,
                      true,
                    );
                  }}
                >
                  {Text({ tid: "REGENERATE_PDF", def: "REGENERATE_PDF" })}
                </Button>
                <Dropdown
                  overlay={specificMenu(selectedUser)}
                  trigger={["click"]}
                  placement='bottomRight'
                >
                  <Button className={`${styles.docIcon}  ${styles.noMargin}`}>
                    <img
                      src={baseUrl + "/pdf.png"}
                      alt='pdf'
                      width={40}
                    />
                  </Button>
                </Dropdown>
              </div>
            </div>
          }
        >
          <div
            className={styles.modalContent}
            id='modalContent'
          >
            <div className={styles.modalTabsAndPdfViewer}>
              <Tabs
                defaultActiveKey='1'
                activeKey={modalActiveTab}
                onChange={setModalActiveTab}
              >
                <Tabs.TabPane
                  tab={`${Text({ tid: "STAGE", def: "Stage" })} ${getNumberInLanguage(1)}`}
                  key='1'
                >
                  <div
                    style={{
                      overflow: "hidden",
                      WebkitOverflowScrolling: "touch",
                    }}
                  >
                    <iframe
                      src={
                        selectedUser?.formUrls?.stage1 !== null
                          ? `${process.env.REACT_APP_PUBLIC_API_MEDIA_BASEURL}${selectedUser?.formUrls?.stage1}`
                          : "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf"
                      }
                      width='100%'
                      height='100%'
                      title='Stage 1 PDF'
                      style={{
                        border: "none",
                        display: "block",
                      }}
                    />
                  </div>
                </Tabs.TabPane>
                {selectedUser.currentStage > eFORMSTATUS.STAGE1APPROVED &&
                  selectedUser.currentStage !==
                    eFORMSTATUS.STAGE2INPROGRESS && (
                    <Tabs.TabPane
                      tab={`${Text({ tid: "STAGE", def: "Stage" })} ${getNumberInLanguage(2)}`}
                      key='2'
                    >
                      <div
                        style={{
                          overflow: "auto",
                          WebkitOverflowScrolling: "touch",
                        }}
                      >
                        <iframe
                          src={
                            selectedUser?.formUrls?.stage2 !== null
                              ? `${process.env.REACT_APP_PUBLIC_API_MEDIA_BASEURL}${selectedUser?.formUrls?.stage2}`
                              : "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf"
                          }
                          width='100%'
                          height='100%'
                          title='Stage 2 PDF'
                          style={{
                            border: "none",
                            display: "block",
                          }}
                        />
                      </div>
                    </Tabs.TabPane>
                  )}
              </Tabs>
            </div>
            <div className={styles.modalTextAreaWrapper}>
              {/* Comment Section */}
              <div style={{ marginBottom: 16 }}>
                <Collapse
                  ghost
                  className='comment-collapse'
                  defaultActiveKey={["1"]}
                  items={[
                    {
                      key: "1",
                      label: (
                        <h4 style={{ margin: 0 }}>
                          {Text({
                            tid: "COMMENTS",
                            def: "Comments",
                          })}
                        </h4>
                      ),
                      children: (
                        <>
                          {Array.isArray(remarks) && remarks.length > 0 ? (
                            <div
                              style={{
                                maxHeight: "200px",
                                overflowY: "auto",
                                border: "1px solid #f0f0f0",
                                borderRadius: "6px",
                                padding: "12px",
                                background: "#fafafa",
                                marginBottom: "12px",
                              }}
                            >
                              {remarks.map((item: any, index: number) => {
                                if (!item || !item.comment) return null;
                                return (
                                  <div
                                    key={index}
                                    style={{
                                      marginBottom: "12px",
                                      borderBottom:
                                        index !== remarks.length - 1
                                          ? "1px solid #e0e0e0"
                                          : "none",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        marginBottom: "4px",
                                      }}
                                    >
                                      <span
                                        style={{
                                          fontSize: "12px",
                                          color: "#888",
                                          fontWeight: 500,
                                        }}
                                      >
                                        {(() => {
                                          const date =
                                            item.updatedOn || item.createdOn;
                                          return date
                                            ? dayjs(date).format(
                                                "DD MMM YYYY, hh:mm A",
                                              )
                                            : "-";
                                        })()}
                                      </span>
                                      <Popconfirm
                                        title={Text({
                                          tid: "DELETE_COMMENT_CONFIRM",
                                          def: "Are you sure to delete this comment?",
                                        })}
                                        onConfirm={() =>
                                          handleDeleteComment(item.id)
                                        }
                                        okText={Text({
                                          tid: "YES",
                                          def: "Yes",
                                        })}
                                        cancelText={Text({
                                          tid: "NO",
                                          def: "No",
                                        })}
                                      >
                                        <Button
                                          type='text'
                                          size='small'
                                          danger
                                          icon={<DeleteOutlined />}
                                        />
                                      </Popconfirm>
                                    </div>
                                    <div
                                      style={{
                                        fontSize: "14px",
                                        color: "#333",
                                        lineHeight: "1.5",
                                        whiteSpace: "pre-wrap",
                                      }}
                                    >
                                      {item.comment}
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          ) : (
                            <div
                              style={{
                                textAlign: "center",
                                padding: "12px",
                                color: "#888",
                                fontStyle: "italic",
                                marginBottom: "12px",
                              }}
                            >
                              {Text({
                                tid: "NO_PREVIOUS_COMMENT",
                                def: "No Previous Comment",
                              })}
                            </div>
                          )}

                          <div
                            style={{
                              display: "flex",
                              gap: "8px",
                              alignItems: "center",
                            }}
                          >
                            <Input.TextArea
                              placeholder={Text({
                                tid: "ENTER_COMMENTS",
                                def: "ENTER_COMMENTS",
                              })}
                              value={modalComment}
                              rows={1}
                              onChange={(e) => setmodalComment(e.target.value)}
                              // disabled={isInProgress(selectedUser.currentStage)}
                              style={{ flex: 1 }}
                            />
                            <Button
                              type='primary'
                              icon={<PlusOutlined />}
                              onClick={handleAddComment}
                              disabled={!modalComment.trim()}
                              title={Text({
                                tid: "ADD_COMMENT",
                                def: "Add Comment",
                              })}
                            />
                          </div>
                        </>
                      ),
                    },
                  ]}
                />
              </div>
            </div>
          </div>
        </FullscreenModal>
      )}
    </>
  );
}

export default AdminDashboard;
